import React from "react";
import { Input } from "./";
import Autocomplete from "@material-ui/lab/Autocomplete";
import FormControl from "@material-ui/core/FormControl";
import  KeyboardArrowDownIcon from  "@material-ui/icons/KeyboardArrowDown";
import CloseIcon from "@material-ui/icons/Close";
import {
  InputAdornment,
  CircularProgress,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import * as Icons from "@material-ui/icons";

export default function ({
  label,
  className,
  style,
  error,
  helperText,
  name,
  value,
  placeholder,
  loading,
  disabled,
  fullWidth,
  tooltip,
  options,
  type,
  ...props
}) {

const shouldShowClearButton =  value?.length > 0 && (props.multiple ? props.clearable : true)
  const [open, setOpen] = React.useState(false);
  return (
    <FormControl style={style} className={className} fullWidth={fullWidth}>
      {/* {label && <InputLabel error={!!error}>{label}</InputLabel>} */}
      <Autocomplete
        {...props}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        options={Array.isArray(options) ? options : []}
        disabled={loading || disabled}
        disableClearable
        renderInput={({ InputProps, ...params }) => (
          <Input
            {...params}
            required={props.required}
            InputProps={{
              ...InputProps,
              ...(loading && {
                startAdornment: (
                  <InputAdornment position="end">
                    <CircularProgress size={20} color="inherit" thickness={6} />
                  </InputAdornment>
                ),
              }),
              endAdornment: (
                <InputAdornment position="end">
                  <div className="flex-row" style={{ alignItems: "end",  paddingRight:"14px"}}>
                  <IconButton
                    size="small"
                    color="primary"
                    onClick={() => {
                      setOpen(!open);
                    }}>
                    <KeyboardArrowDownIcon />
                  </IconButton>
                    {shouldShowClearButton && (
                        <IconButton
                          onClick={() => {
                            props.onChange(
                              null,
                              type ? (type == "string" ? "" : []) : []
                            );
                          }}
                          size="small"
                        >
                          <CloseIcon/>
                        </IconButton>
                      )}
                    {tooltip ? (
                      <Tooltip title={tooltip} arrow>
                        <Icons.Help
                          style={{
                            verticalAlign: "middle",
                            fontSize: "16px",
                            marginLeft: "5px",
                            marginBottom: "5px",
                          }}
                          color="primary"
                        />
                      </Tooltip>
                    ) : null}
                  </div>
                </InputAdornment>
              ),
            }}
            placeholder={loading ? "Loading Options" : placeholder}
            name={name}
            error={!!error}
            helperText={helperText}
            label={label}
          />
        )}
        value={value === undefined ? null : value} // convert undefined to null
      />
    </FormControl>
  );
}
